import React, { useState, useEffect } from 'react';
import { Form, FormGroup, Label, Input } from 'reactstrap';
import CreateTableComponent from '../share/CreateTableComponent';
import { NumberWithCommas } from '../share/NumberWithCommas';
import Tippy from '@tippyjs/react';
import { FaSistrix } from "react-icons/fa";
import 'tippy.js/dist/tippy.css';
import Swal from "sweetalert2";
import { TiTick } from "react-icons/ti";
import { TbReportSearch } from "react-icons/tb";
import { IoCloseOutline } from "react-icons/io5";

export function ChangeAccountFormComponent() {
  const user = JSON.parse(localStorage.getItem("userData"))
  const [selectedSupportId, setSelectedSupportId] = useState('');
  const [oldPaymentName, setOldPaymentName] = useState('');
  const [newPaymentName, setNewPaymentName] = useState('');
  const [file, setFile] = useState(null);
  const [history, setHistory] = useState([]);
  // console.log("history", history);
  // const [message, setMessage] = useState('');
  const [listSupport, setListSupport] = useState([]);
  // console.log("listSupport", listSupport);


  useEffect(() => {
    getHoistoryLog();
    getSupportDataByRold()
  }, [])

  async function getSupportDataByRold() {
    if (user.roldId === "1" || user.roldId === "2") {
      let postData = new FormData();
      postData.append("registerId", user.registerId);
      try {
        let res = await fetch("/api/Support/getSupportNormalUser", {
          method: "POST",
          body: postData,
        });

        const data = await res.json();
        setListSupport(data.dataenum);
      } catch (e) {
        // console.log("err", e)
      }

    }
  }

  async function getHoistoryLog() {
    try {
      let res = await fetch("/api/Support/historyChangePaymentLog", {
        method: "POST",
        headers: {
          "token": user.token
        }
      });

      const data = await res.json();
      setHistory(data.dataenum);
    } catch (e) {
      // console.log("err", e)
    }

  }

  // Handle file change
  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  // Handle form submission
  const handleSubmit = async (event) => {
    event.preventDefault();

    const formData = new FormData();
    formData.append('supportId', Number(selectedSupportId));
    formData.append('newPaymentName', newPaymentName);
    formData.append('payCheckLogFile', file);

    let res = await fetch('/api/Support/saveRequestChangePaymentName', {
      method: 'POST',
      headers: {
        "token": user.token
      },
      body: formData,
    })
    let resJson = await res.json();
    if (resJson.status === 1) {
      Swal.fire({
        icon: "success",
        title: "บันทึกข้อมูลสำเร็จ",
        text: "",
        confirmButtonColor: "#0A66C2",
        confirmButtonText: "ตกลง",
      }).then((result) => {
        window.location.reload();
      });
    } else {
      Swal.fire({
        icon: "error",
        title: "บันทึกข้อมูลไม่สำเร็จ",
        text: `เนื่องจาก ${resJson.message}`,
        confirmButtonColor: "#0A66C2",
        confirmButtonText: "ตกลง",
      });
    }

  };

  // Handle change in selected request
  const handleRequestChange = (event) => {
    // console.log("event.target.value", event.target.value);
    const supportId = event.target.value;
    setSelectedSupportId(supportId);
    const request = listSupport.find(r => r.supportId === supportId);
    setOldPaymentName(request ? request.paymentName : '');
  };


  //function สำหรับรับทราบ ของเจ้าหน้าที่
  const AcceptConsider = async (payCheckLogId, status) => {
    await Swal.fire({
      icon: "info",
      title: `ยืนยันการ${status == 0 ? "อนุมัติ" : "ปฎิเสธ"} หรือไม่ ?`,
      text: "",
      confirmButtonColor: "#0A66C2",
      confirmButtonText: "ตกลง",
    }).then(async (result) => {

      try {
        let postData = new FormData();
        postData.append("payCheckLogId", payCheckLogId);
        postData.append("status", status);
        postData.append("fullname", user.fullName);

        let res = await fetch("/api/Support/considerChangePaymentLog", {
          method: "POST",
          headers: {
            "token": user.token
          },
          body: postData
        });
        let resJson = await res.json();
        if (resJson.status === 1) {
          Swal.fire({
            icon: "success",
            title: "บันทึกข้อมูลสำเร็จ",
            text: "",
            confirmButtonColor: "#0A66C2",
            confirmButtonText: "ตกลง",
          }).then((result) => {
            getHoistoryLog()
            // GetConsiderReportResult();
          });
        }
      } catch (e) {

      }
    });

  }

  const showDataByUser = () => {
    if (user.roldId == "1" || user.roldId == "2") {
      const COLUMNS = [
        {
          Header: "เลขที่อ้างอิง",
          accessor: "supportId",
        },
        {
          Header: "ชื่อบัญชีเดิม",
          accessor: "oldPaymentName",
        },
        {
          Header: "ชื่อบัญชีใหม่",
          accessor: "newPaymentName",
        },
        {
          Header: "สถานะเจ้าหน้าที่ สนพ./สพร.",
          accessor: "flagOfficerApprove",
          Cell: ({ value }) => { return <>{value == null ? "รอการตรวจสอบ" : value == 0 ? "อนุมัติ" : "ไม่อนุมัติ"}</> }

        },
        {
          Header: "สถานะผู้อำนวยการ สนพ./สพร.",
          accessor: "flagDirectorApprove",
          Cell: ({ value }) => { return <>{value == null ? "รอการตรวจสอบ" : value == 0 ? "อนุมัติ" : "ไม่อนุมัติ"}</> }
        },

      ]
      return COLUMNS;
    } else {

      const COLUMNS = [
        {
          Header: "เลขที่อ้างอิง",
          accessor: "supportId",
        },
        {
          Header: "ชื่อบัญชีเดิม",
          accessor: "oldPaymentName",
        },
        {
          Header: "ชื่อบัญชีใหม่",
          accessor: "newPaymentName",
        },

        {
          Header: "สถานะเจ้าหน้าที่ สนพ./สพร.",
          accessor: "flagOfficerApprove",
          Cell: ({ row, value }) => {
            return <>
              {value == null ? (
                <>
                  รอการตรวจสอบ
                  <TiTick
                    className="mx-1 ms-2 style-icon"
                    onClick={() => {
                      AcceptConsider(row.original.payCheckLogId, "0")
                    }}
                  />

                  <IoCloseOutline
                    className="mx-1 ms-2 style-icon"
                    onClick={() => {
                      AcceptConsider(row.original.payCheckLogId, "1")
                    }}
                  />

                </>
              ) : value == "0" ? "อนุมัติ" : "ไม่อนุมัติ"}
              <TbReportSearch className="style-icon mx-2" onClick={() => window.open(row.original.pathFile)} />

            </>
          }
        },
        // {
        //   Header: "สถานะผู้อำนวยการ สนพ./สพร.",
        //   accessor: "flagDirectorApprove",
        //   Cell: ({ value }) => { return <>{value == null ? "รอรับทราบ" : "รับทราบ"}</> }
        // },

      ]
      return COLUMNS;
    }

  }


  return (
    <div className="container mt-5">
      {/* Request selection */}
      {user.roldId === "1" || user.roldId === "2" ? (
        <>
          <Tippy content="ดาวน์โหลดเอกสารขอรับเงินช่วยเหลือหรืออุดหนุน">
            {/* <CallExportSupportForm supportId={row.original.supportId} supportTypeId={row.original.supportTypeId} /> */}
          </Tippy>
          <Form onSubmit={handleSubmit}>
            <FormGroup>
              <Label for="request">เลือกเลขที่อ้างอิงที่ต้องการ</Label>
              <Input
                type="select"
                id="supportId"
                value={selectedSupportId}
                onChange={handleRequestChange}
                required
              >
                <option value="">-- เลือกคำขอ --</option>
                {listSupport?.map(request => (
                  <option key={request.supportId} value={request.supportId}>
                    {request.supportId} จำนวนเงิน {NumberWithCommas(request.amount)} บาท
                  </option>
                ))}
              </Input>
            </FormGroup>

            {/* Old account name */}
            <FormGroup>
              <Label for="oldPaymentName">ชื่อบัญชีเดิม</Label>
              <Input
                type="text"
                id="oldPaymentName"
                value={oldPaymentName}
                disabled
                className="form-control"
              />
            </FormGroup>

            {/* New account name */}
            <FormGroup>
              <Label for="newPaymentName">ชื่อบัญชีใหม่</Label>
              <Input
                type="text"
                id="newPaymentName"
                value={newPaymentName}
                onChange={(e) => setNewPaymentName(e.target.value)}
                required
                className="form-control"
              />
            </FormGroup>

            {/* File upload */}
            <FormGroup>
              <Label for="file">แนบไฟล์ประกอบการเปลี่ยนชื่อบัญชี</Label>
              <Input
                type="file"
                id="payCheckLogFile"
                onChange={handleFileChange}
                required
                className="form-control"
              />
            </FormGroup>

            {/* Submit Button */}
            <div className='d-flex justify-content-center'>
              <button
                className="btn-blue create-button-form"
                type="submit"
              >
                {/* <IoMdCreate className="mx-2" /> */}
                ส่งคำขอ
              </button>
            </div>

          </Form>
          <hr />
          <h3 className="text-center mb-4">ประวัติการยื่นคำขอเปลี่ยนแปลงชื่อบัญชี</h3>
        </>
      ) : null}

      <CreateTableComponent
        column={showDataByUser()}
        dataInput={history}
        showEntrie={true}
        showPage={true}
      />

    </div>
  );
};

